import { types } from 'mobx-state-tree';

const LayoutBox = types.model('LayoutBox', {
  key: types.string,
  title: types.string
});

export default LayoutBox;
